import React, { Component } from "react";

class ViewOnlyHeader extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  
  render() {
    return (
      <header className=" bg-white">
        <div className="layout-width">
          <div className="navbar-header">
            <div className="d-flex justify-content-between align-items-center w-100">
              {/* LOGO */}
              <div className=" ">
                <div to="/" className="logo logo-dark">
                  {/* <span className="logo-sm">
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}assets/logo-color.jpeg`}
                      alt=""
                      height={72}
                    />
                  </span> */}
                  <div className=" d-flex gap-1" >
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}assets/abstart-logo.png`}
                      alt=" "
                      // style={{ width:"140px", height:"46px", objectFit:"cover" }}
                      className="logoSize"
                    />
                    <img
                      src={ this.props.url? this.props.url : `${process.env.REACT_APP_BASE_URL}assets/talentco-new-logo.png`}
                      alt=""
                      // style={{ width:"140px", height:"46px", objectFit:"cover" }}
                      className="logoSize"
                    />
                  </div>
                </div>
                {/* <a href="index.html" className="logo logo-light">
                  <span className="logo-sm">
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}assets/logo-color.jpeg`}
                      alt=""
                      height={22}
                    />
                  </span>
                  <span className="logo-lg">
                    <img
                      src={`${process.env.REACT_APP_BASE_URL}assets/logo-color.jpeg`}
                      alt=""
                      height={17}
                    />
                  </span>
                </a> */}
              </div>
              <div>
              {this.props.name? 
                <h5 className=' md-d-flex headerName mb-0'>Welcome to, 
                  <h5 style={{ color: "#0668D5" }} className=" mb-0 headerName">{this.props.name}</h5> 
                  </h5>:null}
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}

export default ViewOnlyHeader;
